/**
 * Sprint 135 — El cliente del ayudante, desde la pantalla.
 *
 * Vive aparte del componente porque tiene una responsabilidad propia: saber **cuándo no hay
 * asistente**. En el escritorio no existe esta ruta (el asistente es del track web), y en el web
 * puede no haber `ANTHROPIC_API_KEY` configurada. En los dos casos la pantalla tiene que caer sola
 * al camino de siempre —guardar la duda y copiarla para WhatsApp— sin enseñar un error que a quien
 * pregunta no le dice nada.
 */

export interface RespuestaAyuda {
  ok: boolean;
  respuesta?: string;
  /** El asistente dijo que no sabe: hay que escalarlo a un humano. */
  noSupo?: boolean;
  mensaje?: string;
}

/** ¿Tiene sentido ofrecer el ayudante en esta instalación? */
export async function asistenteDisponible(): Promise<boolean> {
  try {
    const r = await fetch('/api/ayuda/estado');
    if (!r.ok) return false;
    const j = (await r.json()) as { disponible?: boolean };
    return j.disponible === true;
  } catch {
    // Escritorio, sin red, o servidor viejo: simplemente no se ofrece.
    return false;
  }
}

export async function preguntarAlAsistente(
  pregunta: string,
  ruta: string,
): Promise<RespuestaAyuda> {
  try {
    const r = await fetch('/api/ayuda', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pregunta, ruta }),
    });
    const j = (await r.json()) as RespuestaAyuda;
    if (!r.ok) return { ok: false, mensaje: j.mensaje ?? 'No pude consultar ahora.' };
    return j;
  } catch {
    return { ok: false, mensaje: 'No pude consultar ahora.' };
  }
}
